'use strict';

/**
 * View for rendering a single location in the select/update location modal
 *
 * @category   View
 * @module     collection.location
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoItemView = require('base/Colido.ItemView');

var template = require('../../templates/partials/select-meta-storages-item.hbs');

var SelectMetaStoragesItemView = ColidoItemView.extend({
    tagName: 'li',

    template: template,

    events: {
        'click': 'onClickItem',
    },

    /**
     * Is triggered, when the item is clicked
     * We will notify the layout view with the details
     */
    onClickItem: function() {
        var level = this.$el.parents('.lane').data('level');
        this.triggerMethod('location:selected', level, this.model);
    },
});

module.exports = SelectMetaStoragesItemView;